<h2 mat-dialog-title>Warnung</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Schließen</button>
</mat-dialog-actions>
